import {
  BELIEVE_CONTROLLER_URL,
  DISTRIBUTION_URL,
  LABEL_URL,MODIFICATION_URL
} from "../../../services/common-urls";
import { MHTTPCL, JSON_STRING, } from "../../../services/http/http-client";

export const ContractsService = {
  fetchContracts: () =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contracts_tab"
    }),
  getScrollContracts: (multi_search_term, start) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "get_contracts",
      multi_search_term,
      start
    }),
  searchContracts: multi_search_term =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "get_contracts",
      multi_search_term
    }),
  fetchContractDetailsTabInfo: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_info",
      contract_id
    }),
  fetchContractDetailsTabSetup: contract_id =>
    MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
      action: "contracts_contract_setup_tab",
      contract_id
    }).then(res => {
      return {
        ...res,
        data: {
          ...res.data,
          contract: res.data?.response?.contract,
          label_statuses: res.data?.response?.label_statuses,
          related_products: res.data?.response?.related_products
        }
      };
    }),
  fetchDetailsTabContractsItem: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "advance_contract_contract_item_tab",
      contract_id
    }),
  fetchDetailsTabGetContracts: contract_id =>
    MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
      action: "contracts_get_contract",
      contract_id
    }),
  fetchDetailsTabRoyaltyRates: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "advance_contract_royalty_rates_tab",
      contract_id
    }),
  fetchDetailsTabRoyaltyRatesMechanical: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "mechanical_contract_royalty_rate_tab",
      contract_id,
      output: JSON_STRING
    }),
  fetchDetailsTabTurnoverScale: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_turnover_scale",
      contract_id
    }),
  fetchDetailsTabLicencingNr: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_licencing_performance_info",
      contract_id
    }),
  fetchDetailsTabRecoupables: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "advance_contract_recoupables_believespecial_tab",
      contract_id
    }),
  fetchDetailsTabRecoupablesMechanical: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "advance_contract_recoupables_tab",
      contract_id
    }),
  fetchDetailsTabAdvances: contract_id =>
    MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
      action: "contract_advances_tab",
      contract_id
    }),
  fetchDetailsTabAdvancesAutoBalances: (contract_id, types) =>
    MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
      action: "contract_auto_balances",
      contract_id,
      types
    }),
  fetchContractDeductionsTab: (contract_id) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_deductions_tab",
      contract_id,
    }),

  fetchContractDeductionsBoxData: (contract_id, deduction_target) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_deductions_box_data",
      contract_id,
      deduction_target: deduction_target

    }),
  addEditDeductionModalData: (contract_deduction_id) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_edit_deduction_modal_data",
      contract_deduction_id: contract_deduction_id,
    }),
  searchContractDeductionAccounts: (search) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_deduction_search_accounts",
      search: search,
    }),
  searchContractDeductionReleases: (search) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_deduction_search_releases",
      search: search,
    }),
  searchContractDeductionProducts: (search) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_deduction_search_products",
      search: search,
    }),
  saveContractDeduction: (contractDeduction) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "save_contract_deduction",
      ...contractDeduction

    }),
  deleteContractDeduction: (contract_deduction_id) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_contract_deduction",
      contract_deduction_id: contract_deduction_id
    }),
  isReleasesAlreadyInSameRA: (contract_id, release_ids) =>
    MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
      action: "is_releases_already_in_same_ra",
      contract_id: contract_id,
      release_ids: release_ids
    }),

  fetchDetailsTabBalances: (contract_id, type_str, startrow = 0) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_balances",
      contract_id,
      type_str,
      startrow
    }),
  fetchDetailsTabAutoBalances: (contract_id, types, types_not) =>
    MHTTPCL.post(LABEL_URL, {
      action: "contract_auto_balances",
      contract_id,
      types,
      types_not
    }),
  fetchDetailsTabHistory: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "advance_contract_statement_history_tab",
      contract_id
    }),
  fetchDetailsTabSpecial: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "advance_contract_special_tab",
      contract_id
    }).then(res => {
      return {
        ...res,
        data: {
          ...res.data,
          specialContract: res.data.contract
        }
      };
    }),
    

    mechContractEditProductFormData: ({contract_pos_id}) =>
      MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "mech_contract_edit_product_form_data",
        contract_pos_id:contract_pos_id
      }),
  autoFillFromReleases: ({contract_id,release_ids}) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "auto_fill_from_releases",
      contract_id,
      release_ids:release_ids
    }),
    mechAutoFillFromReleases: ({contract_id,release_ids,share,share_cc}) =>
      MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "mech_contract_auto_fill_album",
        contract_id,
        release_ids:release_ids,
        share:share,
        share_cc:share_cc
      }),
    contractReleaseCount: contract_id =>
      MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "contract_release_count",
        contract_id
      }),
  autoFillFromTracks: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_track_release_form",
      contract_id,
      output: JSON_STRING
    }),
  getTemplates: ({ contract_id = 0 } = {}) =>
    MHTTPCL.get(DISTRIBUTION_URL, {
      action: "view_order_proforma_invoice_select_template",
      section: "orders",
      template_section: "royalty_contract",
      section_name: "royalty",
      controller_name: "label.pl",
      action_name: "royalty_contract_report",
      identifier: "contract_id",
      id: contract_id,
      output: JSON_STRING
    }),
  deleteContract: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_contract",
      contract_id
    }),
  saveAutoFill: ({ contract_id, ids }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_selected_releases",
      contract_id,
      ids
    }),
  deleteContractItems: contract_pos_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_contract_relation",
      contract_pos_id
    }),
  newReleases: (contract_id, start, search) =>
    MHTTPCL.post(LABEL_URL, {
      section: "common",
      action: "searchUnrelatedReleases",
      item_id: contract_id,
      forWhich: "l_contracts",
      start,
      search
    }),

  isAlreadyIn: ({ contract_id, release_ids }) =>
    MHTTPCL.post(BELIEVE_CONTROLLER_URL, {
      action: "is_releases_already_in_same_ra",
      contract_id,
      release_ids
    }),
  makeReleaseRelation: ({ contract_id, release_ids, share, search }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "common",
      action: "makeReleaseRelation",
      item_id: contract_id,
      for_which: "l_contracts",
      selected_releases_ids: release_ids,
      share,
      search
    }),
  saveReleases: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_related_releases",
      contract_id
    }),
  newTracks: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "get_contract_unrelated_tracks",
      contract_id
    }),
  searchUnrelatedTracks: ({ contract_id, search }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "search_contract_unrelated_tracks",
      contract_id,
      search
    }),
  saveTracks: ({ contract_id, track_ids }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_contract_tracks_selection",
      contract_id,
      track_ids
    }),
  newProducts: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "get_contract_unrelated_products",
      contract_id
    }),
    

mechContractEditProductFormData: contract_pos_id =>
      MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "mech_contract_edit_product_form_data",
        contract_pos_id
      }),
  searchUnrelatedProducts: ({ contract_id, search }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "search_contract_unrelated_products",
      contract_id,
      search
    }),
  saveProducts: ({ contract_id, product_ids }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_contract_products_selection",
      contract_id,
      product_ids
    }),
  physicalRoyaltyForm: ({ contract_id, royalty_option_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "init_physical_ro_data",
      contract_id,
      royalty_option_id
    }),
  savePhysicalRoyalty: payload =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "save_physical_ro_data",
      ...payload
    }),
  digitalRoyaltyForm: ({ contract_id, royalty_option_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "init_digital_ro_data",
      contract_id,
      royalty_option_id
    }),
  saveDigitalRoyalty: payload =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "save_digital_ro_data",
      ...payload
    }),
  deleteRoyaltyRate: royalty_option_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_royalty_option",
      royalty_option_id
    }),
  addReserveSettingSetup: (contract_id, mechanical_flag) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_reserve_setting_rule",
      contract_id,
      mechanical_flag
    }),
  addReverseSetup: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_reserve_setting_rule",
      contract_id
    }),
  deleteReverseSetup: (contract_id, reserve_setting_id) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_reserve_setting",
      contract_id,
      reserve_setting_id
    }),
  deleteRoyaltyScale: royalty_scale_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_contract_scale",
      royalty_scale_id
    }),
  newQtyScale: contract_id =>
    MHTTPCL.get(LABEL_URL, {
      section: "royalty",
      action: "royalty_scale_modal",
      contract_id,
      output: JSON_STRING
    }),
  saveQtyScale: payload =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "add_edit_scale",
      ...payload
    }),
  editScale: ({ contract_id, royalty_scale_id }) =>
    MHTTPCL.get(LABEL_URL, {
      section: "royalty",
      action: "royalty_scale_modal",
      contract_id,
      royalty_scale_id,
      output: JSON_STRING
    }),
  newTurnoverScale: contract_id =>
    MHTTPCL.get(LABEL_URL, {
      section: "royalty",
      action: "turnover_scale_modal",
      contract_id,
      output: JSON_STRING
    }),
  editTurnoverScale: ({ contract_id, royalty_scale_id }) =>
    MHTTPCL.get(LABEL_URL, {
      section: "royalty",
      action: "turnover_scale_modal",
      contract_id,
      royalty_scale_id,
      output: JSON_STRING
    }),
  submitRoyaltyScales: payload =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "save_turnover_scale",
      ...payload
    }),
  fetchTurnoverScale: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_turnover_scale",
      contract_id
    }),
  licencingNrAddForm: ({ contract_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "init_performance_ro_data",
      contract_id
    }),
  performanceLicencingNrForm: ({ contract_id, royalty_option_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "init_performance_ro_data",
      contract_id,
      royalty_option_id
    }),
  savePerformanceLicencingNr: payload =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "save_performance_ro_data",
      ...payload
    }),
  thirdpartyLicencingNrForm: ({ contract_id, royalty_option_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "init_thirdparty_ro_data",
      contract_id,
      royalty_option_id
    }),
  saveThirdpartyLicencingNr: payload =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "save_thirdparty_ro_data",
      ...payload
    }),
  addThirdpartyForm: ({ contract_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "init_thirdparty_ro_data",
      contract_id
    }),
  addLicensing: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "new_licensing_royalty_option",
      contract_id
    }),
  deleteRecoupables: royalty_cost_group_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_contract_cost_group",
      royalty_cost_group_id
    }),
  addRecoupables: ({ contract_id, income_flag }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "new_contract_royalty_cost_group",
      contract_id,
      income_flag
    }),
  autoFetchForm: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "autofetch_form",
      contract_id
    }),
  submitAutoFetchForm: ({ contract_id, external_table2, external_id2, text02 }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "submit_auto_fetch",
      contract_id,
      external_table2,
      external_id2,
      text02
    }),
  deleteAutoFetch: relation_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_contract_autofetch_relation",
      relation_id
    }),
  deleteBalance: balance_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "delete_balance",
      balance_id
    }),
  searchBalance: ({ contract_id, type_str, str }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "contract_balance_search",
      contract_id,
      type_str,
      str
    }),
  addBalance: ({ contract_id, type_str }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "new_contract_balance_3",
      contract_id,
      type_str
    }),
  autoFetchForAllContracts: () =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "auto_fetch_for_all_contracts"
    }),
  autoFetchLabelSupplier: contract_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "auto_fill_via_autofetch",
      contract_id
    }),
  addContractBalance: ({ contract_id, type }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "new_contract_balance",
      contract_id,
      type
    }),
  saveTemplate: ({ contract_id, template_name }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "set_template_name",
      contract_id,
      template_name
    }),

  searchContractRelatedItems: ({ contract_id, relation, search }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "search_contract_related_items",
      contract_id,
      relation,
      search
    }),
  removeContractReleases: ({ contract_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "remove_contract_releases",
      contract_id,
    }),
  removeContractProducts: ({ contract_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "remove_contract_products",
      contract_id,
    }),
  removeContractTracks: ({ contract_id }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "royalty",
      action: "remove_contract_tracks",
      contract_id,
    }),

    contractRelatedReleases: contract_id =>
      MHTTPCL.post(LABEL_URL, {
        section: "royalty",
        action: "contract_related_releases",
        contract_id
      }),
      modifyJSON: ({ table, kVal, name, value,key,modify_type,json_op }) => MHTTPCL.post(MODIFICATION_URL, {
        kVal,
        name,
        value,
        table,
        key,
        modify_type,
        json_op,
        json_key: '',
        output: JSON_STRING,
        
    }),
};
